window.helpers = window.helpers || {};

import './handlebars-helpers-data';
import './handlebars-helpers-control';
import './handlebars-helpers-format';

